"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextRenderer = exports.TextControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const antd_1 = require("antd");
const assert_never_1 = require("../common/assert-never");
const react_2 = require("@jsonforms/react");
function TextControl({ label, visible, required, data, handleChange, path, schema, enabled, id, uischema, }) {
    const setInitialValue = (0, react_1.useCallback)((value) => {
        if (typeof value !== "number")
            return value;
        const coercedValue = coerceToString(value);
        handleChange(path, coercedValue);
        return coercedValue;
    }, [handleChange, path]);
    const ariaLabel = label || schema.description;
    const options = uischema.options ?? {};
    const formItemProps = "formItemProps" in uischema ? uischema.formItemProps : {};
    const { tooltip: formItemTooltip, ...formItemPropsWOTooltip } = formItemProps ?? {};
    const tooltip = options.tooltip ? options.tooltip : formItemTooltip ?? "";
    const placeholderText = options.placeholderText;
    const form = antd_1.Form.useFormInstance();
    const rules = [
        {
            required: required || options.required,
            whitespace: required,
            message: required ? `${label} is required` : "",
        },
        ...(options?.rules ? options.rules : []),
    ];
    (0, react_1.useEffect)(() => {
        form.setFieldValue(path, setInitialValue(data ?? schema.default));
    }, [data, form, path, schema.default, setInitialValue]);
    return !visible ? null : ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: label, id: id, name: path, validateTrigger: ["onBlur"], rules: rules, tooltip: tooltip, ...formItemPropsWOTooltip, children: (0, jsx_runtime_1.jsx)(TextControlInput, { "aria-label": ariaLabel, disabled: !enabled, autoComplete: "off", onChange: (e) => handleChange(path, e.target.value), placeholder: placeholderText ?? (label.toLowerCase() || "value"), textControlOptions: options }) }));
}
exports.TextControl = TextControl;
function TextControlInput({ textControlOptions, ...rest }) {
    const { inputProps, ...restTextControlOptions } = textControlOptions;
    if (!(`type` in restTextControlOptions) ||
        restTextControlOptions.type === undefined) {
        return ((0, jsx_runtime_1.jsx)(antd_1.Input, { ...rest,
            ...inputProps }));
    }
    switch (restTextControlOptions.type) {
        case "multiline":
            return ((0, jsx_runtime_1.jsx)(antd_1.Input.TextArea, { ...rest,
                ...inputProps }));
        case "singleline":
            return ((0, jsx_runtime_1.jsx)(antd_1.Input, { ...rest,
                ...inputProps }));
        case "password":
            return ((0, jsx_runtime_1.jsx)(antd_1.Input.Password, { ...rest,
                ...inputProps }));
        default:
            try {
                (0, assert_never_1.assertNever)(restTextControlOptions.type);
            }
            catch (e) {
                return ((0, jsx_runtime_1.jsx)(antd_1.Input, { ...rest,
                    ...inputProps }));
            }
    }
}
function coerceToString(value) {
    return value.toString();
}
exports.TextRenderer = (0, react_2.withJsonFormsControlProps)(TextControl);
